export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                  片多多影视
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed max-w-xs">
                片多多影视致力于打造高清免费在线观影平台，海量热门电影电视剧综艺动漫，片多多免费观看不卡顿，超清画质畅享流畅观影体验。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                {[
                  { label: '热门榜单', href: '#ranking' },
                  { label: '精选推荐', href: '#cards' },
                  { label: '精彩预告', href: '#media' },
                  { label: '最新动态', href: '#updates' },
                  { label: '常见问题', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-4">影视分类</h3>
              <ul className="space-y-2.5">
                {['热门电影', '电视剧集', '综艺节目', '动漫动画', '纪录片'].map((cat) => (
                  <li key={cat}>
                    <span className="text-sm text-background-400 whitespace-nowrap">{cat}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-500 leading-relaxed">
                更多合作伙伴即将入驻，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              片多多影视 &copy; {new Date().getFullYear()} 版权所有 | 高清免费在线影视平台
            </p>
            <p className="text-xs text-background-600">
              片多多高清免费 · 片多多免费观看 · 片多多高清不卡
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}